<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bWoN7m/tc-custom/9780062562135.jpg?1731180341474" alt="This image is the cover for the book Of the Abyss, Mancer Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Of the Abyss, Mancer Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p>After decades of strife, peace has finally been achieved in Kavet—but at a dark cost.  Sorcery is outlawed, and anyone convicted of consorting with the beings of the other realms—the Abyssi and the Numini—is put to death. The only people who can even discuss such topics legally are the scholars of the Order of the Napthol, who give counsel when questions regarding the supernatural planes arise.</p><p>Hansa Viridian, a captain in the elite guard unit tasked with protecting Kavet from sorcery, has always led a respectable life. But when he is implicated in a sorcerer’s crimes, the only way to avoid execution is to turn to the Abyss for help—specifically, to a half-Abyssi man he’s sworn he hates, but whose physical attraction he cannot deny.                              </p><p>Hansa is only the first victim in a plot that eventually drags him, a sorcerer named Xaz, and a Sister of the Napthol named Cadmia into the depths of the Abyss, where their only hope of escape is to complete an infernal task that might cost them their lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amelia Atwater-Rhodes
      </h2>
      
      <p class="authorDescription body article"><P><B>AMELIA ATWATER-RHODES</B> is the author of the Mancer Trilogy:&#160;<I>Of the Abyss, Of the Divine,&#160;</I>and&#160;<I>Of the Mortal Realm.</I> She is also the author of three YA series, Den of Shadows, The Kiesha&#8217;ra, and The Maeve&#8217;ra, which have been ALA Quick Picks for Young Adults, School Library Journal Best Books of the Year and VOYA Best Science Fiction, Fantasy, and Horror List Selections.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28747bec